import React from 'react'
import { getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { Button, Icon } from 'semantic-ui-react'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import { 
  StdCard,
} from 'components'

const VendorSignContract = (props) => {

  const {
    valueForm,
  } = props

  const getVendorSignedContract = () =>{
    if(valueForm&&valueForm.attachments){
      let file = valueForm.attachments.find(x=>x.documentType.toLowerCase()=='ct08'&&x.deleted==false)
      return file||null
    }
  }

  return (
    <React.Fragment>
    {valueForm&&valueForm.status==10?
      <ProcurementBody>
        <StdCard title='File Vendor Signed Contract' style={{ marginTop: '10px' }}>
          {getVendorSignedContract()?
            // <Button icon labelPosition='right' onClick={()=>window.open(getVendorSignedContract().urlPath)}>
            <Button icon labelPosition='right' onClick={()=>window.location.href = getVendorSignedContract().urlPath}>
              Download File Vendor Signed Contract
              <Icon name='download' />
            </Button>
            :
            <div style={{color:'red', fontSize:'1.5rem', fontWeight:'bold'}}>
              Please contact administrator
            </div>
          }
        </StdCard>
      </ProcurementBody>
      :
      null
    }
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  valueForm: getFormValues('formContract')(state),
})

const mapDispatchToProps = ({
  
})

export default connect(mapStateToProps, mapDispatchToProps)(VendorSignContract)